import "./ButtonImportMission.scss";
import Icon from "core/icon/Icon";

const ButtonImportMission = ({ id, onClick, isOpenModal }) => {
  return (
    <button
      className={`import-mission-button ${isOpenModal ? "pink" : "grey"}`}
      onClick={onClick}
      id={id}
    >
      <p>import</p>
      <Icon disabled={true} icon={"arrowhead-right"} color={"white"} />
    </button>
  );
};

export default ButtonImportMission;
